import { Component } from "react";
import ReactMde from "react-mde";

import showdown from "showdown";

import "react-mde/lib/styles/scss/react-mde-all.scss";

// TODO: Move converter into common spot for both comments and redux form editor widget
const converter = new showdown.Converter({
    tables: true,
    tasklists: true,
    strikethrough: true,
    parseImgDimensions: true,
    emoji: true,
    simpleLineBreaks: true
});

export class TextareaMD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "preview"
        };
    }
    
    setSelectedTab = (tab) => {
        this.setState({
            selectedTab: tab
        });
    };
    
    render() {
        return (
            <ReactMde
                value={this.props.value}
                onChange={this.props.onChange}
                selectedTab={this.state.selectedTab}
                onTabChange={this.setSelectedTab}
                disablePreview={false}
                generateMarkdownPreview={(markdown) => Promise.resolve(converter.makeHtml(markdown))}
            />
        );
    }
}
